import { c as _c } from "react/compiler-runtime";
import { getSpartanRevealElementProps, SPARTAN_REVEAL_PRESET, SPARTAN_REVEAL_ROLE } from '@/app/lcv/components/sections/spartan/products/shared/reveal';
import { renderSpartanProductSectionTitle } from '@/app/lcv/components/sections/spartan/products/shared/section-header/render-title';
import styles from '@/app/lcv/components/sections/spartan/products/shared/section-header/styles.module.css';
import { getSpartanProductSectionHeaderTracking } from '@/app/lcv/components/sections/spartan/products/shared/section-header/tracking';
import type { SpartanProductSectionHeaderProps } from '@/app/lcv/components/sections/spartan/products/shared/section-header/types';
import { cn } from '@/app/utils/cn';
import { createDataAttributes } from '@/app/utils/createDataAttributes';
export const SpartanProductSectionHeader = t0 => {
  const $ = _c(25);
  const {
    className,
    eyebrow,
    titleLead,
    title,
    description,
    actions,
    trackingPrefix,
    tone: t1,
    layout: t2,
    titleFont: t3
  } = t0;
  const tone = t1 === undefined ? "light" : t1;
  const layout = t2 === undefined ? "default" : t2;
  const titleFont = t3 === undefined ? "display" : t3;
  if (!title) {
    return null;
  }
  let t4;
  if ($[0] !== actions || $[1] !== className || $[2] !== description || $[3] !== eyebrow || $[4] !== layout || $[5] !== title || $[6] !== titleFont || $[7] !== titleLead || $[8] !== tone || $[9] !== trackingPrefix) {
    const tracking = getSpartanProductSectionHeaderTracking(trackingPrefix);
    const isDark = tone === "dark";
    const toneTitleColor = isDark ? "text-white" : "text-gray-900";
    const isDmaxTitle = titleFont === "dmax";
    const isMuxTitle = titleFont === "mux";
    const titleClassName = cn(isDmaxTitle && cn(styles.dmaxTitle, "text-red-500", isDark ? "where-strong:text-white" : "where-strong:text-gray-900"), isMuxTitle && cn(styles.muxTitle, toneTitleColor), titleFont === "display" && cn("font-display text-h1 leading-none", toneTitleColor));
    const titleLeadClassName = isDmaxTitle ? cn(styles.dmaxTitleLead, "text-red-500") : isMuxTitle ? styles.muxTitleLead : styles.titleLead;
    const titleStackClassName = isDmaxTitle ? styles.dmaxTitleStack : isMuxTitle ? styles.muxTitleStack : undefined;
    const titleRevealOrder = eyebrow ? 1 : 0;
    let t5;
    if ($[11] !== titleLead) {
      t5 = titleLead?.trim();
      $[11] = titleLead;
      $[12] = t5;
    } else {
      t5 = $[12];
    }
    const trimmedTitleLead = t5;
    const titleNode = renderSpartanProductSectionTitle({
      title,
      titleLead,
      titleClassName,
      titleLeadClassName,
      titleRevealOrder,
      titleTestId: tracking.title
    });
    const hasActionsSlot = actions !== undefined;
    const t6 = titleRevealOrder + 1;
    let t7;
    if ($[13] !== t6) {
      t7 = getSpartanRevealElementProps({
        order: t6,
        preset: SPARTAN_REVEAL_PRESET.content,
        role: SPARTAN_REVEAL_ROLE.fade
      });
      $[13] = t6;
      $[14] = t7;
    } else {
      t7 = $[14];
    }
    const actionsRevealProps = t7;
    let t8;
    if ($[15] !== actions || $[16] !== actionsRevealProps) {
      t8 = () => <div className="shrink-0" {...actionsRevealProps}>{actions}</div>;
      $[15] = actions;
      $[16] = actionsRevealProps;
      $[17] = t8;
    } else {
      t8 = $[17];
    }
    const renderActions = t8;
    const renderTitleWithActions = () => {
      if (trimmedTitleLead && title.trim()) {
        return <div className={titleStackClassName}><span className={cn(titleLeadClassName, titleFont === "display" && titleClassName, isMuxTitle && toneTitleColor)} aria-hidden="true" {...getSpartanRevealElementProps({
            order: titleRevealOrder,
            preset: SPARTAN_REVEAL_PRESET.content,
            role: SPARTAN_REVEAL_ROLE.copy
          })}>{trimmedTitleLead}</span><div className="lg:flex lg:items-center lg:justify-between lg:gap-6"><h2 className={titleClassName} {...getSpartanRevealElementProps({
              order: titleRevealOrder,
              preset: SPARTAN_REVEAL_PRESET.content,
              role: SPARTAN_REVEAL_ROLE.copy
            })} {...createDataAttributes({
              test: tracking.title
            })}><span className="sr-only">{`${trimmedTitleLead} `}</span><span className={styles.bodyLine} dangerouslySetInnerHTML={{
                __html: title
              }} /></h2>{renderActions()}</div></div>;
      }
      return <div className="lg:flex lg:items-center lg:justify-between lg:gap-6">{titleNode}{renderActions()}</div>;
    };
    let t9;
    if ($[18] !== className) {
      t9 = cn("where-span:text-inline-wrap where-small:text-body-2-fixed mb-6 md:mb-8 lg:mb-10 lg:grid lg:grid-cols-12 lg:gap-x-6", className);
      $[18] = className;
      $[19] = t9;
    } else {
      t9 = $[19];
    }
    const t10 = createDataAttributes({
      test: tracking.header
    });
    const t11 = !!description && layout === "default";
    const t12 = !!description && layout === "equal";
    const t13 = !description && hasActionsSlot;
    const t14 = !description && !hasActionsSlot;
    let t15;
    if ($[20] !== t11 || $[21] !== t12 || $[22] !== t13 || $[23] !== t14) {
      t15 = cn({
        "lg:col-span-5": t11,
        "lg:col-span-6": t12,
        "lg:col-span-12": t13,
        "lg:col-span-8": t14
      });
      $[20] = t11;
      $[21] = t12;
      $[22] = t13;
      $[23] = t14;
      $[24] = t15;
    } else {
      t15 = $[24];
    }
    t4 = <header className={t9} {...t10}><div className={t15}>{eyebrow ? <p className={cn("text-sub-h1 font-noto-bold mb-2", isDark ? "text-white" : "text-gray-900")} {...getSpartanRevealElementProps({
          preset: SPARTAN_REVEAL_PRESET.content,
          role: SPARTAN_REVEAL_ROLE.copy
        })} {...createDataAttributes({
          test: tracking.eyebrow
        })} dangerouslySetInnerHTML={{
          __html: eyebrow
        }} /> : null}{actions ? renderTitleWithActions() : titleNode}</div>{description ? <div className={cn("text-body-1 pt-4 lg:col-span-6 lg:col-start-7", isMuxTitle && "lg:pt-2", isDmaxTitle && !trimmedTitleLead && "lg:pt-1", isDmaxTitle && !!trimmedTitleLead && "lg:pt-5", isDark ? "text-gray-50" : "text-gray-700")} dangerouslySetInnerHTML={{
        __html: description
      }} {...getSpartanRevealElementProps({
        order: titleRevealOrder + 1,
        preset: SPARTAN_REVEAL_PRESET.content,
        role: SPARTAN_REVEAL_ROLE.copy
      })} {...createDataAttributes({
        test: tracking.description
      })} /> : null}</header>;
    $[0] = actions;
    $[1] = className;
    $[2] = description;
    $[3] = eyebrow;
    $[4] = layout;
    $[5] = title;
    $[6] = titleFont;
    $[7] = titleLead;
    $[8] = tone;
    $[9] = trackingPrefix;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
};